var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0C3891",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1973 13.1553C14.197 13.7119 13.9756 14.2456 13.5819 14.639C13.1881 15.0324 12.6542 15.2532 12.0976 15.2529C11.541 15.2527 11.0073 15.0313 10.6139 14.6375C10.2206 14.2438 9.99972 13.7098 10 13.1533C10.0003 12.5967 10.2217 12.063 10.6154 11.6696C11.0092 11.2762 11.5431 11.0554 12.0997 11.0557C12.6563 11.0559 13.19 11.2773 13.5833 11.6711C13.9767 12.0648 14.1976 12.5988 14.1973 13.1553ZM14.2602 16.807H10.063V29.9444H14.2602V16.807ZM20.8919 16.807H16.7156V29.9444H20.8499V23.0504C20.8499 19.2099 25.8552 18.8531 25.8552 23.0504V29.9444H30V21.6233C30 15.1491 22.5918 15.3904 20.8499 18.5698L20.8919 16.807Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.5bc77957a779c927d199c957bb29b753.svg";